import { TemplateDeployment, StackOutput } from "types/generated";

export type OutputWithStack = StackOutput & {
  stackId: string;
  stackName: string;
  uniqueId: string;
};

export const getDeploymentOutputs = (deployment: TemplateDeployment): OutputWithStack[] => {
  const allOutputs: OutputWithStack[] = [];

  deployment.stacks.forEach((stack) => {
    stack.outputs.forEach((output) => {
      allOutputs.push({
        ...output,
        stackId: stack.id,
        stackName: stack.name,
        uniqueId: `${stack.id}-${output.id}`,
      });
    });
  });

  return allOutputs;
};
